export const generateURL = (path: string) => {
  const fullHostname = window.location.origin;

  return `${fullHostname}${path}`;
};
